"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericDropdownWidget = exports.DropdownButtonWidget = exports.getDropdownStylesByType = exports.DropdownType = void 0;
var tslib_1 = require("tslib");
/* eslint-disable deprecation/deprecation */
var React = tslib_1.__importStar(require("react"));
var react_1 = require("react");
var ReactDOM = tslib_1.__importStar(require("react-dom"));
var DropdownArrow_1 = require("../icons/resources/DropdownArrow");
var Colors_1 = require("../styles/Colors");
var FocusIndicators_1 = require("../styles/FocusIndicators");
var PreventUserSelect_1 = require("../styles/PreventUserSelect");
var TabStyles_1 = require("../styles/TabStyles");
var TextEllipsis_1 = require("../styles/TextEllipsis");
var Declarative_1 = require("../utils/Declarative");
var DomUtil_1 = require("../utils/DomUtil");
var FindIndex_1 = require("../utils/FindIndex");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var Overlay_1 = require("../utils/Overlay");
var FlyoutListMenuWidget_1 = require("./FlyoutListMenuWidget");
var Sizing = TabStyles_1.TabStyles.Sizing, Colors = TabStyles_1.TabStyles.Colors, Spacing = TabStyles_1.TabStyles.Spacing, Typography = TabStyles_1.TabStyles.Typography;
var SidePadding = 8;
var DropdownType;
(function (DropdownType) {
    DropdownType[DropdownType["Outline"] = 0] = "Outline";
    DropdownType[DropdownType["Line"] = 1] = "Line";
    DropdownType[DropdownType["Text"] = 2] = "Text";
})(DropdownType = exports.DropdownType || (exports.DropdownType = {}));
function getLabelStyle(options) {
    return {
        display: 'block',
        fontSize: Typography.Sizing.Default,
        fontWeight: 'normal',
        color: options.primaryTextColors.normal,
        lineHeight: "19px",
    };
}
function getOutlineDropdownStyle(options) {
    return {
        container: {},
        button: {
            base: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, TextEllipsis_1.TextEllipsis), PreventUserSelect_1.PreventUserSelect), { backgroundColor: 'transparent', borderColor: options.primaryLineColors.normal, borderRadius: Sizing.BorderRadius, borderStyle: 'solid', borderWidth: Sizing.BorderWidth, color: options.primaryTextColors.normal, fontSize: Typography.Sizing.Default, fontWeight: 'normal', height: Sizing.RowHeight, outline: 'none', overflow: 'hidden', paddingLeft: SidePadding - Sizing.BorderWidth, paddingRight: Spacing.LargeSpace + SidePadding - Sizing.BorderWidth }),
            interactive: {
                hover: {
                    backgroundColor: options.hoverBackgroundColor,
                    borderColor: options.primaryLineColors.hover,
                },
                active: {
                    borderColor: options.primaryLineColors.active
                },
                focusVisible: FocusIndicators_1.DefaultFocusIndicator(),
                disabled: {
                    borderColor: options.primaryLineColors.disabled,
                    color: options.primaryTextColors.disabled
                }
            }
        },
        value: {
            lineHeight: options.innerRowHeight + "px"
        },
        iconContainer: {
            display: 'inline-block',
            position: 'absolute',
            right: 0,
        },
        icon: {
            marginTop: (options.innerRowHeight - DropdownArrow_1.DropdownArrowIcon.height) / 2
        },
        label: getLabelStyle(options)
    };
}
function getLineDropdownStyle(options) {
    return {
        container: {},
        button: {
            base: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, TextEllipsis_1.TextEllipsis), PreventUserSelect_1.PreventUserSelect), { backgroundColor: 'transparent', borderBottomColor: options.primaryLineColors.normal, borderBottomStyle: 'solid', borderBottomWidth: Sizing.BorderWidth, borderLeft: 'none', borderRight: 'none', borderTop: 'none', color: options.primaryTextColors.normal, fontSize: Typography.Sizing.Default, fontWeight: 'normal', height: Sizing.RowHeight, outline: 'none', overflow: 'hidden', paddingLeft: SidePadding - Sizing.BorderWidth, paddingRight: Spacing.LargeSpace + SidePadding - Sizing.BorderWidth }),
            interactive: {
                hover: {
                    backgroundColor: options.hoverBackgroundColor,
                    borderBottomColor: options.primaryLineColors.hover,
                },
                active: {
                    borderBottomColor: options.primaryLineColors.active
                },
                focusVisible: FocusIndicators_1.DefaultFocusIndicator(),
                disabled: {
                    borderBottomColor: options.primaryLineColors.disabled,
                    color: options.primaryTextColors.disabled
                }
            }
        },
        value: {
            top: Sizing.BorderWidth,
            lineHeight: options.innerRowHeight + "px",
        },
        iconContainer: {
            bottom: 1,
            position: 'absolute',
            right: 1,
            top: 1,
        },
        icon: {
            marginTop: (options.innerRowHeight - DropdownArrow_1.DropdownArrowIcon.height) / 2
        },
        label: getLabelStyle(options),
    };
}
function getTextDropdownStyle(options) {
    return {
        container: {
            display: 'inline-block',
            width: 'auto'
        },
        button: {
            base: tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { backgroundColor: 'transparent', border: 'none', color: options.primaryTextColors.normal, cursor: 'pointer', display: 'inline-block', fontSize: Typography.Sizing.Default, fontWeight: 'normal', height: Sizing.RowHeight, lineHeight: Sizing.RowHeight + "px", overflow: 'hidden', paddingLeft: SidePadding, paddingRight: DropdownArrow_1.DropdownArrowIcon.width }),
            interactive: {
                hover: {
                    backgroundColor: options.hoverBackgroundColor,
                },
                active: {
                    color: options.primaryTextColors.active
                },
                disabled: {
                    color: options.primaryTextColors.disabled,
                    cursor: 'default',
                },
                focusVisible: FocusIndicators_1.DefaultFocusIndicator(),
            }
        },
        value: {
            lineHeight: 'inherit'
        },
        iconContainer: {
            position: 'absolute'
        },
        icon: {
            marginTop: (Sizing.RowHeight - DropdownArrow_1.DropdownArrowIcon.height) / 2
        },
        label: getLabelStyle(options),
    };
}
var getStyles = function () {
    var innerRowHeight = Sizing.RowHeight - (Sizing.BorderWidth * 2);
    var normalPrimaryLineColors = {
        normal: Colors.L6,
        hover: Colors.L8,
        active: Colors.L9,
        focus: Colors.Focus,
        disabled: Colors.L9Disabled
    };
    var normalPrimaryTextColors = {
        normal: Colors_1.TextColors.Primary,
        disabled: Colors_1.TextColors.Disabled,
        active: Colors.Black,
    };
    var darkBackgroundPrimaryLineColors = {
        normal: Colors.WhiteTransparentLine,
        hover: Colors.WhiteTransparentLineHover,
        active: Colors.White,
        focus: Colors.White,
        disabled: Colors.WhiteDisabled
    };
    var darkBackgroundPrimaryTextColors = {
        normal: Colors_1.InvertTextColors.Primary,
        disabled: Colors_1.InvertTextColors.Disabled,
        active: Colors.White,
    };
    var normalOptions = {
        innerRowHeight: innerRowHeight,
        primaryLineColors: normalPrimaryLineColors,
        primaryTextColors: normalPrimaryTextColors,
        hoverBackgroundColor: Colors_1.TextFieldHoverColor,
    };
    var darkBackgroundOptions = {
        innerRowHeight: innerRowHeight,
        primaryLineColors: darkBackgroundPrimaryLineColors,
        primaryTextColors: darkBackgroundPrimaryTextColors,
        hoverBackgroundColor: 'transparent',
    };
    var OutlineDropdownStyle = getOutlineDropdownStyle(normalOptions);
    var OutlineDropdownDarkBackgroundStyle = getOutlineDropdownStyle(darkBackgroundOptions);
    var LineDropdownStyle = getLineDropdownStyle(normalOptions);
    var LineDropdownDarkBackgroundStyle = getLineDropdownStyle(darkBackgroundOptions);
    var TextDropdownStyle = getTextDropdownStyle(normalOptions);
    var TextDropdownDarkBackgroundStyle = getTextDropdownStyle(darkBackgroundOptions);
    return {
        OutlineDropdownStyle: OutlineDropdownStyle,
        OutlineDropdownDarkBackgroundStyle: OutlineDropdownDarkBackgroundStyle,
        LineDropdownStyle: LineDropdownStyle,
        LineDropdownDarkBackgroundStyle: LineDropdownDarkBackgroundStyle,
        TextDropdownStyle: TextDropdownStyle,
        TextDropdownDarkBackgroundStyle: TextDropdownDarkBackgroundStyle
    };
};
function getDropdownStylesByType(dropdownType, onDarkBackground) {
    var styles = getStyles();
    switch (dropdownType) {
        case DropdownType.Outline:
            return onDarkBackground ? styles.OutlineDropdownDarkBackgroundStyle : styles.OutlineDropdownStyle;
        case DropdownType.Line:
            return onDarkBackground ? styles.LineDropdownDarkBackgroundStyle : styles.LineDropdownStyle;
        case DropdownType.Text:
            return onDarkBackground ? styles.TextDropdownDarkBackgroundStyle : styles.TextDropdownStyle;
        default:
            throw new Error("DropdownWidget attempted to render invalid DropdownType: " + dropdownType);
    }
}
exports.getDropdownStylesByType = getDropdownStylesByType;
var DropdownButtonWidget = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownButtonWidget, _super);
    function DropdownButtonWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownButtonWidget.prototype.componentDidUpdate = function () {
        // We lose focus on spacebar/enter keydown, so the active state needs to be manually set
        if (this.props.dropdownOpen && this.state.active) {
            this.setState({ active: false });
        }
    };
    DropdownButtonWidget.prototype.getDropdownIconState = function () {
        return {
            active: this.state.active || this.props.dropdownOpen,
            disabled: this.props.disabled,
            hover: this.state.hover,
            onDarkBackground: this.props.onDarkBackground,
        };
    };
    DropdownButtonWidget.prototype.render = function () {
        var dropdownStyles = getDropdownStylesByType(this.props.dropdownType, this.props.onDarkBackground);
        var buttonStyles = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, dropdownStyles.button.base), { boxSizing: 'border-box', position: 'relative' }), Declarative_1.conditional(this.props.dropdownOpen, dropdownStyles.button.interactive.active));
        var blockProps = {
            'aria-atomic': true,
            'aria-expanded': this.props.dropdownOpen,
            'aria-haspopup': 'listbox',
            'aria-labelledby': this.props.labelledById,
            'aria-live': (this.state.focus ? 'assertive' : 'off'),
            'aria-controls': (this.props.dropdownOpen ? this.props.dropdownId : undefined),
            'aria-relevant': 'text',
            'data-tb-test-id': this.props.testId,
            disabled: this.props.disabled,
            onKeyDown: this.props.onKeyDown,
            role: 'combobox',
            style: buttonStyles,
            tabIndex: this.props.disabled ? undefined : 0,
            title: this.props.title,
        };
        var spanProps = {
            style: dropdownStyles.value,
            title: Declarative_1.conditional(typeof this.props.children === 'string', this.props.children)
        };
        return react_1.createElement('div', blockProps, react_1.createElement('span', spanProps, this.props.children), react_1.createElement('div', { style: dropdownStyles.iconContainer }, react_1.createElement(DropdownArrow_1.DropdownArrowIcon.icon, tslib_1.__assign({ style: dropdownStyles.icon }, this.getDropdownIconState()))));
    };
    DropdownButtonWidget = tslib_1.__decorate([
        InteractiveDom_1.InteractiveDomHoCDecorator
    ], DropdownButtonWidget);
    return DropdownButtonWidget;
}(React.Component));
exports.DropdownButtonWidget = DropdownButtonWidget;
/**
 * @deprecated use `SingleSelectDropdown`
 */
var GenericDropdownWidget = /** @class */ (function (_super) {
    tslib_1.__extends(GenericDropdownWidget, _super);
    function GenericDropdownWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonEl = null;
        _this.enabledItems = [];
        _this.labelId = DomUtil_1.generateId();
        _this.dropdownId = DomUtil_1.generateId();
        _this.toggleMenu = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState(function (prevState, props) {
                var isNowOpen = !prevState.isOpen;
                if (isNowOpen) {
                    if (props.onOpen) {
                        props.onOpen();
                    }
                }
                else {
                    if (props.onClose) {
                        props.onClose();
                    }
                }
                return { isOpen: isNowOpen };
            });
        };
        _this.handleSelect = function (value) {
            _this.props.onSelect(value, _this.state.isOpen);
            _this.onRequestClose();
        };
        // Handle key presses as defined by ARIA https://www.w3.org/TR/wai-aria-practices/#menu
        _this.handleKeyDown = function (e) {
            if (_this.props.disabled || _this.state.isOpen || e.ctrlKey || e.altKey || e.metaKey) {
                return;
            }
            var selectedIndex = _this.getIndexOfSelectedItem();
            if (Declarative_1.isAlphabeticChar(e.key)) {
                var nextIndexOfFirstLetter = FindIndex_1.findIndex(_this.enabledItems, function (item) {
                    return !!item.keyboardAccessibleValue &&
                        item.keyboardAccessibleValue.charAt(0).toUpperCase() === e.key.toUpperCase();
                }, selectedIndex + 1, _this);
                if (nextIndexOfFirstLetter > -1) {
                    _this.props.onSelect(_this.enabledItems[nextIndexOfFirstLetter].value, _this.state.isOpen);
                }
            }
            else {
                var value = undefined;
                switch (e.key) {
                    case ' ':
                    case 'Enter':
                        _this.toggleMenu();
                        break;
                    case 'ArrowUp':
                        if (selectedIndex > 0) {
                            value = _this.enabledItems[selectedIndex - 1].value;
                        }
                        break;
                    case 'ArrowDown':
                        if (selectedIndex < _this.enabledItems.length - 1) {
                            value = _this.enabledItems[selectedIndex + 1].value;
                        }
                        break;
                    case 'Home':
                        value = _this.enabledItems[0].value;
                        break;
                    case 'End':
                        value = _this.enabledItems[_this.enabledItems.length - 1].value;
                        break;
                    case 'Escape':
                        // swallow ESC events that plausibly originate from focus being returned to the button after the popup closed
                        if (e.repeat) {
                            break;
                        }
                        else {
                            return;
                        }
                    default:
                        // Do not prevent default or stopPropagation on non-handled key presses
                        return;
                }
                if (value) {
                    _this.props.onSelect(value, _this.state.isOpen);
                }
                e.preventDefault();
                e.stopPropagation();
            }
        };
        _this.onRequestClose = function () {
            _this.toggleMenu();
        };
        _this.setButtonElement = function (ref) {
            // eslint-disable-next-line react/no-find-dom-node
            _this.buttonEl = ReactDOM.findDOMNode(ref);
        };
        _this.getAnchorClientRect = function () {
            var _a;
            return (_a = _this.buttonEl) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        };
        if (props.menuItemInfos.filter(function (item) { return !!item.menuItemInfos; }).length > 0) {
            throw Error('Dropdowns may not contain submenus');
        }
        _this.setEnabledItems(_this.props.menuItemInfos);
        _this.state = {
            buttonText: _this.getButtonDisplayValue(),
            isOpen: false
        };
        return _this;
    }
    GenericDropdownWidget.prototype.componentDidUpdate = function () {
        this.setEnabledItems(this.props.menuItemInfos);
        var buttonText = this.getButtonDisplayValue();
        if (buttonText !== this.state.buttonText) {
            this.setState({ buttonText: buttonText });
        }
    };
    GenericDropdownWidget.prototype.getMenuWidth = function () {
        var potentialWidth = undefined;
        if (this.props.flyoutStyle) {
            var flyoutWidth = this.props.flyoutStyle.width;
            if (flyoutWidth === 'auto') { // special-case: want dynamically-sized flyout but it will evaluate to 0 when parsing as int
                return 'auto';
            }
            potentialWidth = parseInt(flyoutWidth, 10);
        }
        else if (this.props.containerStyle) {
            potentialWidth = parseInt(this.props.containerStyle.width, 10);
        }
        if (this.buttonEl) {
            var boundingWidth = this.buttonEl.getBoundingClientRect().width;
            potentialWidth = Math.max(boundingWidth, potentialWidth || 0);
        }
        return potentialWidth;
    };
    GenericDropdownWidget.prototype.getIndexOfSelectedItem = function () {
        var _this = this;
        return FindIndex_1.findIndex(this.enabledItems, function (item) { return item.value === _this.props.selectedValue; }, 0, this);
    };
    GenericDropdownWidget.prototype.setEnabledItems = function (menuItemInfos) {
        this.enabledItems = (menuItemInfos || []).filter(function (item) {
            // eslint-disable-next-line deprecation/deprecation
            return !item.isDivider && !item.disabled && !item.isUnselectable;
        });
    };
    GenericDropdownWidget.prototype.getButtonDisplayValue = function () {
        var selectedItemIndex = this.getIndexOfSelectedItem();
        return selectedItemIndex > -1 ? (this.enabledItems[selectedItemIndex].textForDropdownButton || '') : (this.props.placeholder || '');
    };
    GenericDropdownWidget.prototype.render = function () {
        var _this = this;
        var dropdownStyles = getDropdownStylesByType(this.props.dropdownType, this.props.onDarkBackground);
        var shouldShowLabel = !!this.props.label;
        var containerStyle = tslib_1.__assign(tslib_1.__assign({}, this.props.containerStyle), dropdownStyles.container);
        var flyoutWidth = this.getMenuWidth();
        var flyoutStyle = tslib_1.__assign(tslib_1.__assign({}, this.props.flyoutStyle), { width: flyoutWidth });
        var focusIndex = (this.state.isOpen && this.props.selectedValue) ?
            FindIndex_1.findIndex(this.props.menuItemInfos, function (item) { return item.value === _this.props.selectedValue; }) :
            0;
        return (react_1.createElement('div', {
            style: containerStyle,
            'data-tb-test-id': Declarative_1.makeTestId(this.props.testId, 'Dropdown')
        }, Declarative_1.conditional(shouldShowLabel, react_1.createElement('label', {
            style: dropdownStyles.label,
            id: this.labelId
        }, this.props.label)), react_1.createElement('div', {}, react_1.createElement(DropdownButtonWidget, {
            disabled: this.props.disabled,
            dropdownId: this.dropdownId,
            dropdownOpen: this.state.isOpen,
            dropdownType: this.props.dropdownType,
            onDarkBackground: this.props.onDarkBackground,
            interactiveStyles: dropdownStyles.button.interactive,
            onKeyDown: this.handleKeyDown,
            pointerClick: this.toggleMenu,
            labelledById: Declarative_1.conditional(shouldShowLabel, this.labelId),
            ref: this.setButtonElement,
            testId: Declarative_1.makeTestId(this.props.testId, 'DropdownButton'),
            title: this.props.title
        }, this.state.buttonText)), Declarative_1.conditional(this.state.isOpen, react_1.createElement(FlyoutListMenuWidget_1.GenericFlyoutListMenuWidget, {
            toggleEl: this.buttonEl,
            getAnchorClientRect: this.getAnchorClientRect,
            stackingRootId: this.props.stackingRootId,
            // eslint-disable-next-line deprecation/deprecation
            shouldReturnFocusToToggleEl: this.props.shouldReturnFocusOnClose,
            anchorOrigin: {
                vertical: Overlay_1.VerticalOriginOption.bottom,
                horizontal: Overlay_1.HorizontalOriginOption.left
            },
            allowAutoPosition: true,
            // eslint-disable-next-line deprecation/deprecation
            scrollingRootId: this.props.scrollingRootId,
            handleScrollOnScrollingRoot: this.toggleMenu,
            onSelect: this.handleSelect,
            id: this.dropdownId,
            __INTERNAL__focusIndex: focusIndex,
            role: 'listbox',
            maxHeight: this.props.maxHeight,
            menuStyle: flyoutStyle,
            menuItemInfos: this.props.menuItemInfos,
            requestCloseAll: this.onRequestClose,
            zIndex: this.props.zIndex,
            testId: this.props.testId,
        }))));
    };
    GenericDropdownWidget.defaultProps = {
        shouldReturnFocusOnClose: true,
    };
    return GenericDropdownWidget;
}(React.Component));
exports.GenericDropdownWidget = GenericDropdownWidget;
//# sourceMappingURL=DropdownWidget.js.map